import React, { useState, useEffect } from 'react';
import { saveProfileSettings, getProfileSettings } from '../../helper/apiHelper.js'
import { toast, Bounce } from 'react-toastify';

function Profile() {
    const [fName, setFName] = useState('');
    const [lName, setLName] = useState('');
    const [userName, setUserName] = useState('#');

    const save = async () => {
        const data = {
            fName: fName,
            lName: lName
        }
        const result = await saveProfileSettings(JSON.stringify(data));
        if (result) {
            toast.success("Saved!", {
                position: "top-center",
                transition: Bounce,
            });
        } else {
            toast.error("Something went wrong!", {
                position: "top-center",
                transition: Bounce,
            });
        }
        fetchData();
    }

    useEffect(() => {
        fetchData();
        const userdata = JSON.parse(localStorage.getItem('user'));
        const user = userdata.wallet.username;
        setUserName(user);
    }, []);

    const fetchData = async () => {
        try {
            const response = await getProfileSettings();
            if (response) {
                setFName(response.f_name);
                setLName(response.l_name);
            }

        } catch (error) {
            console.error('Error fetching general settings:', error);
        }
    };

    return (
        <>
            <div className='col-6'>
                <div className="settings-profile-section">
                    <div className="d-flex justify-content-center align-items-center text-center">
                        <div className="user-profile-pic rounded-circle width-150 height-150 f-size-90 f-weight-300">{userName.charAt(0).toUpperCase()}</div>
                    </div>
                    <div className="form-group mt-4">
                        <label htmlFor="fname" className='general-menu-text'>First Name: </label>
                        <input type="text" className="common-input mt-1 col-12" id="fname" placeholder=" First Name..." value={fName} onChange={(e) => { setFName(e.target.value) }} />
                    </div><div className="form-group mt-4">
                        <label htmlFor="lname" className='general-menu-text'>Last Name:  </label>
                        <input type="text" className="common-input mt-1 col-12" id="lname" placeholder=" Last Name..." value={lName} onChange={(e) => { setLName(e.target.value) }} />
                    </div>
                    <div className="save-settings-btn mt-3 d-flex justify-content-center">
                        <button className='general-save-btn' onClick={async () => {
                            await save();
                        }}>save</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Profile;
